import { Component } from '@angular/core';
import { AdminSettings } from 'src/app/enums/settings';
import { PermissionsService } from 'src/app/services/permissions.service';
@Component({
    selector: 'app-admin-setari',
    templateUrl: './admin-setari.component.html',
    styleUrls: ['./admin-setari.component.scss'],
})
export class AdminSetariComponent {
    readonly AdminSettings = AdminSettings;
    selectedComponent!: AdminSettings;

    componentMapping: Record<AdminSettings, string> = {
        [AdminSettings.CONFIGURARI]: 'app-configurari',
        [AdminSettings.TYPE_IMAGE_DIMENSIONS]: 'app-type-imagine',
        [AdminSettings.CRONS]: 'app-crons',
    };

    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        if (
            !this.permissionsService.hasPermission(
                "autcom-module.administrative.configurations.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== AdminSettings.CONFIGURARI
            );
        }
        if (
            !this.permissionsService.hasPermission(
                "autcom-module.administrative.image-types.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== AdminSettings.TYPE_IMAGE_DIMENSIONS
            );
        }
        if (
            !this.permissionsService.hasPermission(
                "autcom-module.administrative.crons.list"
            )
        ) {
            this.componentKeys = this.componentKeys.filter(
                (item) => item !== AdminSettings.CRONS
            );
        }
    }
}
